import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ImagePlus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const TYPES = ["image/jpeg", "image/png", "image/webp"];

export function checkFile(t, file) {
  if (!file) return false;
  if (!TYPES.includes(file.type)) {
    toast.error(t("errors.unsupported_format"));
    return false;
  }
  if (file.size > 10 * 1024 * 1024) {
    toast.error(t("errors.file_too_large"));
    return false;
  }
  return true;
}

export const PhotoPicker = ({ preview, onFile, onRemove, testId = "photo" }) => {
  const { t } = useTranslation();
  const input = useRef();
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
      <button
        type="button"
        onClick={() => input.current?.click()}
        className="relative h-40 w-32 rounded-[999px_999px_18px_18px] overflow-hidden border-2 border-dashed border-[hsl(var(--border))] hover:border-[hsl(var(--accent))] grid place-items-center bg-[hsl(var(--secondary))] transition-colors"
        data-testid={`${testId}-dropzone`}
        aria-label={t("wizard.photo_choose")}
      >
        {preview ? <img src={preview} alt="" className="absolute inset-0 h-full w-full object-cover" data-testid={`${testId}-preview`} /> : <ImagePlus size={28} className="opacity-60" />}
      </button>
      <div className="space-y-2">
        <div className="flex gap-2 flex-wrap">
          <button type="button" className="btn-ghost !py-2.5" onClick={() => input.current?.click()} data-testid={`${testId}-choose-btn`}>
            <ImagePlus size={16} /> {preview ? t("wizard.photo_change") : t("wizard.photo_choose")}
          </button>
          {preview && onRemove && (
            <button type="button" className="btn-ghost !py-2.5" onClick={onRemove} data-testid={`${testId}-remove-btn`}>
              <Trash2 size={16} /> {t("wizard.photo_remove")}
            </button>
          )}
        </div>
        <p className="text-xs text-[hsl(var(--muted-foreground))] max-w-sm">{t("wizard.photo_hint")}</p>
      </div>
      <input
        ref={input}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        data-testid={`${testId}-file-input`}
        onChange={(e) => {
          const f = e.target.files?.[0];
          e.target.value = "";
          if (checkFile(t, f)) onFile(f);
        }}
      />
    </div>
  );
};
